import "./WorkCardStyles.css";
import { NavLink } from "react-router-dom";

const WorkCard = (props) => {
  return (
            <div className="project-card">
                <img src={props.imgsrc} alt="Projects"/>
                <h2 className="project-title">{props.title}</h2>
                <div className="pro-details">
                    <p>{props.text}</p>
                    <div className="pro-btns">
                        <NavLink to={props.view} target="_blank" className="btn">View</NavLink>
                        <NavLink to="/contact" target="_blank" className="btn">Source</NavLink>
                    </div>
                </div>

            </div>
  )
}

export default WorkCard;